export const meta = "my7ju82";
export const liveStatus = "lg1tahs";
export const secondaryAction = "s109tafn";

// Displays when measurements are being taken for responsive card
export const loading = "l1nvtkez";
export const title = "t1ikwzo9";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");